import { API } from "../../../api/api";
import { HomeAPIRoutes } from "./apiRoutes";

const _getUserInfo = () => {
    return API.request({
        routeID: HomeAPIRoutes.GET_USER_INFO
    });
};

export const homeAPI = {
    getLoginStatus: API.getLoginStatus,
    getUserInfo: _getUserInfo
};
